import React, { useEffect, useState } from "react";
import { getGameReport, getGamesReportFilters } from "../../../Infrastructure/Services/GameReportService";
import { getWithExpiry } from "../../../Domain/Helpers/LocalStorageHelper";
import { toast } from "react-toastify";
import { getChildrenList, hideDuplicates, prepareJsonArray } from "../../../Domain/Helpers/MultiselectHelper";
import UILabelInput from "../../../Domain/Components/UI/LabelInput/LabelInput";
import { inputType } from "../../../Domain/Constants/InputType";
import { formatArrayForSelectInput } from "../../../Domain/Helpers/SelectInputHelper";
import UIMultiselect from "../../../Domain/Components/UI/Multiselect/Multiselect";
import UIMultiselectModal from "../../../Domain/Components/UI/MultiSelectModal/MultiselectModal";
import { styleType } from "../../../Domain/Constants/StyleType";
import UIButton from "../../../Domain/Components/UI/Button/Button";
import { formatDate } from "../../../Domain/Helpers/DateHelper";
import UITable from "../../../Domain/Components/UI/Table/Table";
import CSVExport from "../../../Domain/Components/Functional/CSVExport/CSVExport";
import UIGameConfigFilter from "../../../Domain/Components/UI/GameConfigFilter/UIGameConfigFilter";

function GameReportPage(props) {
    const [filters, setFilters] = useState(null);
    const [casinos, setCasinos] = useState();
    const [agregators, setAgregators] = useState();
    const [providers, setProviders] = useState();
    const [gameConfigs, setGameConfigs] = useState();
    const [report, setReport] = useState(null);
    const [waitingForReport, setWaitingForReport] = useState(false);

    useEffect(() => {
        const token = getWithExpiry("token");
        if (token === null) {
            props.setLoggedIn(false);
            return;
        }

        getGamesReportFilters(token).then((data) => {
            if (data) {
                setFilters(data);
            } else {
                toast.error("Failed to retreive game report filter data");
                setFilters({});
            }
        })
    }, [])

    useEffect(() => {
        if (filters && filters.operators) {
            let tmpCasinos = [];

            filters.operators.forEach(o => {
                tmpCasinos = tmpCasinos.concat(o.casinos);
            });

            setCasinos(tmpCasinos);
        }
    }, [filters]);

    const onOperatorsSelected = () => {
        setTimeout(() => {
            let tmpCasinos = getChildrenList(filters.operators, "operators", "casinos");

            setCasinos(tmpCasinos);
        }, 1000)

    }

    useEffect(() => {
        if (casinos) {
            let tmpAgregators = getChildrenList(casinos, "casinos", "providers")
            setAgregators(tmpAgregators);
        }
    }, [casinos])

    const onCasinosSelected = () => {
        setTimeout(() => {
            let tmpAgregators = getChildrenList(casinos, "casinos", "providers")
            setAgregators(tmpAgregators);
        }, 1000)
    }

    useEffect(() => {
        if (agregators) {
            let tmpProviders = getChildrenList(agregators, "agregators", "providers", true, "name");
            setProviders(tmpProviders);
        }
    }, [agregators])

    const onAgregatorsSelected = () => {
        setTimeout(() => {
            let tmpProviders = getChildrenList(agregators, "agregators", "providers", true, "name");
            setProviders(tmpProviders);
        }, 1000)
    }

    const onFilterFormSubmit = async(e) => {
        e.preventDefault();
        let token = getWithExpiry('token');
        if (token === null) {
            props.setLoggedIn(false);
            return;
        }

        const form = e.target;
        const formData = new FormData(form);
        let formJson = prepareJsonForSending(formData);

        setWaitingForReport(true);

        let tmpReport = await getGameReport(token, formJson);
        setReport(tmpReport);
        setWaitingForReport(false);
    }

    const prepareJsonForSending = (formData) => {
        let formJson = Object.fromEntries(formData.entries());

        for (var key in formJson) {
            if (formJson[key] === "") delete formJson[key];
        }

        formJson.gameConfigs = prepareJsonArray(formJson, "gameConfigs");
        formJson.operators = prepareJsonArray(formJson, "operators", true);
        formJson.casinos = prepareJsonArray(formJson, "casinos", true);
        formJson.providers = prepareJsonArray(formJson, "providers", true);
        formJson.currencies = prepareJsonArray(formJson, "currencies", true);
        formJson.agregators = prepareJsonArray(formJson, "agregators", true);

        if (formJson.dateTimeFrom) {
            formJson.dateTimeFrom = formatDate(formJson.dateTimeFrom);
        }

        if (formJson.dateTimeTo) {
            formJson.dateTimeTo = formatDate(formJson.dateTimeTo);
            formJson.dateTimeTo = formJson.dateTimeTo.slice(0, -2) + "59";
        }

        return formJson;
    }

    const columnTitles = [
        "Operator",
        "Casino",
        "Agregator",
        "Vendor",
        "Game",
        "RTP",
        "Currency", 
        "Rate",
        "GGR",
        "GGR(exch)",
        "Bet",
        "Bet(exch)",
        "Win",
        "Win(exch)",
        "Players",
        "Sessions",
        "Transactions"
    ];

    const objectKeys = [
        "operator",
        "casino",
        "agregator",
        "provider",
        "gameName",
        "rtp",
        "currency",
        "exchangeRate",
        "ggr",
        "ggrExchanged",
        "totalBetAmount",
        "totalBetAmountExchanged",
        "totalWinAmount",
        "totalWinAmountExchanged",
        "totalPlayers",
        "totalSessions",
        "totalTransactions"
    ];

    return (<>
        <div className="container">
            <div className="d-flex justify-content-between">
                <h3>Games Report</h3>
            </div>
            <div className="mt-2">
                {
                    filters === null ?
                        <div className="w-100 mt-4 d-flex justify-content-center">
                            <div className="spinner-border" role="status">
                                <span className="visually-hidden">Loading...</span>
                            </div>
                        </div> :
                        Object.keys(filters).length === 0 ? <p className="text-danger">Failed to load filters</p> :
                            <form className="row" method="post" onSubmit={onFilterFormSubmit}>
                                <div className="col-md-6">
                                    <UIMultiselectModal title={"Operators"}
                                        id={"operators"}
                                        options={filters.operators}
                                        displayKey={"company_name"}
                                        onConfirm={onOperatorsSelected} />
                                    <UIMultiselectModal title={"Casinos"}
                                        id={"casinos"}
                                        options={casinos}
                                        displayKey={"company_name"}
                                        onConfirm={onCasinosSelected} />
                                    <UIMultiselectModal title={"Agregators"}
                                        id={"agregators"}
                                        options={hideDuplicates(agregators)}
                                        displayKey={"name"}
                                        onConfirm={onAgregatorsSelected} />
                                    <UIMultiselectModal title={"Vendors"}
                                        id={"providers"}
                                        options={hideDuplicates(providers)}
                                        displayKey={"name"} />
                                    <UIGameConfigFilter title={"Game Configs"}
                                        id={"gameConfigs"}
                                        displayKey={"name"} 
                                        operatorId={"operators"}
                                        casinosId={"casinos"}
                                        agregatorsId={"agregators"}
                                        providersId={'providers'}
                                        setLoggedIn={props.setLoggedIn}
                                        />
                                </div>
                                <div className="col-md-6">
                                    <UIMultiselectModal title={"Currencies"}
                                        id={"currencies"}
                                        options={filters.currencies}
                                        displayKey={"iso_code"} />
                                    <UILabelInput inputType={inputType.SELECT}
                                            labelText={"Exchange currency"}
                                            inputId={"exchangeCurrency"}
                                            required={false}
                                            disabled={false}
                                            selectOptions={formatArrayForSelectInput(filters.currencies, "iso_code", true)}
                                            />
                                    <UILabelInput inputType={inputType.DATETIME}
                                        labelText={"From"}
                                        disabled={false}
                                        required={false}
                                        inputId={"dateTimeFrom"} />
                                    <UILabelInput inputType={inputType.DATETIME}
                                        labelText={"To"}
                                        disabled={false}
                                        required={false}
                                        inputId={"dateTimeTo"} />
                                    <UILabelInput inputType={inputType.SELECT}
                                            labelText={"Group By"}
                                            inputId={"groupBy"}
                                            required={false}
                                            disabled={false}
                                            selectOptions={[
                                                {
                                                    value: null,
                                                    display: ''
                                                },
                                                {
                                                    value: 'day',
                                                    display: 'day'
                                                },
                                                {
                                                    value: 'month',
                                                    display: 'month'
                                                }
                                            ]}
                                            />
                                </div>
                                <div className="col-md-12 mt-2">
                                <UIButton buttonType={"submit"} buttonText={"SEARCH"} styleType={styleType.FADEBLACK} additionalClass="w-100" />
                                </div>
                            </form>
                            
                }

                <div className="mt-2">
                    {waitingForReport && 
                    <div className="w-100 mt-4 d-flex justify-content-center">
                    <div className="spinner-border" role="status">
                        <span className="visually-hidden">Loading...</span>
                    </div>
                </div>}
                {report &&
                <>
                    <UITable columnTitles={columnTitles}
                    data={report}
                    objectKeys={objectKeys}
                    primaryKey={'id'}
                    preventDelete={true} />

                    <div className="mt-2 mb-2">
                        <CSVExport buttonText={"Download Report"} 
                        data={report} 
                        objectKeys={objectKeys} 
                        fileHeaders={columnTitles} 
                        fileTitle="games-report"/>
                    </div>
                  </>  
                }
                </div>
            </div>
        </div>
    </>)
}

export default GameReportPage;